import React from "react";
import Navbar from "../../containers/NavbarContainer";
import Sidebar from "../../components/SidebarComponent";
import { Segment, Responsive } from "semantic-ui-react";

class DesktopContainer extends React.Component {
  render() {
    return (
      <Responsive minWidth={Responsive.onlyTablet.minWidth}>
        <style>
          {`body{
            background-color:#f6f9fe
            }`}
        </style>
        <Sidebar activeTab={this.props.location.pathname} />
        <div
          style={{
            marginLeft: 182
          }}>
          <Navbar />

          <Segment basic>{this.props.children}</Segment>
        </div>
      </Responsive>
    );
  }
}

export default DesktopContainer;



// WEBPACK FOOTER //
// ./src/components/Container/DesktopContainer.js